import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
interface FinalCTAProps {
  onCheckout?: () => void;
}
export function FinalCTA({
  onCheckout
}: FinalCTAProps) {
  return <section className="bg-navy text-white py-24 md:py-32 relative overflow-hidden" data-id="element-67">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-68">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[120px]" data-id="element-69"></div>
      </div>

      <div className="container mx-auto px-4 max-w-3xl relative z-10 text-center" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-71">
          <h2 className="text-3xl md:text-5xl font-bold mb-8 font-serif" data-id="element-72">
            La decisión es simple
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-slate-300 font-light mb-12 leading-relaxed" data-id="element-73">
            <p data-id="element-74">
              Puedes seguir posponiéndolo. Seguir pensando que emprender es
              demasiado complicado. Seguir creyendo que esto no es para ti.
              Seguir atada a la misma rutina de siempre.
            </p>
            <p data-id="element-75">O puedes dar hoy un paso distinto.</p>
            <p data-id="element-76">Uno pequeño, sí. Pero importante.</p>
            <p data-id="element-77">
              Uno que te acerque a una nueva habilidad, una nueva posibilidad y
              una nueva forma de empezar a construir algo propio.
            </p>
          </div>

          <div className="max-w-xl mx-auto mb-16" data-id="element-78">
            <p className="text-xl md:text-2xl font-serif text-gold italic mb-4" data-id="element-79">
              Tu celular puede seguir siendo solo una distracción…
            </p>
            <p className="text-xl md:text-2xl font-serif text-white mb-6" data-id="element-80">
              O puede convertirse en el inicio de algo nuevo para ti.
            </p>
            <p className="text-lg text-slate-400 uppercase tracking-widest font-semibold" data-id="element-81">
              La decisión está en tus manos.
            </p>
          </div>

          <div id="pricing" className="bg-white/5 border border-white/10 rounded-3xl p-8 md:p-12 backdrop-blur-sm" data-id="element-82">
            <h3 className="text-2xl md:text-3xl font-bold text-gold mb-2" data-id="element-83">
              IA Express 2026
            </h3>
            <p className="text-lg mb-6" data-id="element-84">
              Lanza tu mini-negocio visual desde tu celular en 48 horas
            </p>

            <div className="mb-8" data-id="element-85">
              <div className="flex justify-center items-center gap-4 mb-3" data-id="element-86">
                <span className="text-2xl text-slate-400 line-through decoration-rose-500 decoration-2" data-id="element-87">
                  $27 USD
                </span>
                <span className="bg-rose-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-88">
                  75% OFF
                </span>
              </div>
              <div className="text-5xl md:text-6xl font-bold text-gold" data-id="element-89">
                $6.39{' '}
                <span className="text-2xl text-white font-normal" data-id="element-90">USD</span>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm text-slate-300 mb-10 text-left max-w-2xl mx-auto" data-id="element-91">
              <div className="flex items-center gap-2" data-id="element-92">
                <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-93"></div>
                guía completa paso a paso
              </div>
              <div className="flex items-center gap-2" data-id="element-94">
                <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-95"></div>
                estrategias aplicadas de IA
              </div>
              <div className="flex items-center gap-2" data-id="element-96">
                <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-97"></div>
                estructura para crear tu oferta
              </div>
              <div className="flex items-center gap-2" data-id="element-98">
                <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-99"></div>
                recursos de apoyo
              </div>
              <div className="flex items-center gap-2" data-id="element-100">
                <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-101"></div>
                bonos de implementación
              </div>
              <div className="flex items-center gap-2" data-id="element-102">
                <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-103"></div>
                acceso inmediato
              </div>
            </div>

            <CTAButton text="SÍ, QUIERO EMPEZAR HOY" href="https://iaexpres2026.com/cart/46495237374142:1" size="xl" data-id="element-104" />
            <p className="text-sm text-slate-400 mt-4" data-id="element-105">
              Un solo pago. Acceso simple. Primer paso hacia una nueva
              oportunidad.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}